import mutations from "./mutations";

export default {
  mutations,
};
